<template>
  <div class="k-disclaimer bg-white-high-emphasis bottom-0 left-0 right-0">
    <div class="w-full k-disclaimer__content mx-auto">
      <div class="w-full flex justify-end">
        <KButton :aria-label="content.disclaimerTitle" class="text-sm text-blue capitalize w-min" @click="openModal" @keypress.enter.space="openModal" textOnly>{{ content.disclaimerTitle }}</KButton>
      </div>
       <div id="kbyg_footers" class="text-xs hidden md:block" v-dompurify-html="disclaimerText" />
      <KModal v-if="showDisclaimerModal" @close="showDisclaimerModal = false" ariaModalLabel="Disclaimer Modal">
        <template #content>
          <div :aria-describedby="$id('disclaimerModalDescription')" :aria-labelledby="$id('disclaimerModalTitle')" class="flex flex-col items-center justify-center">
            <h2 :id="$id('disclaimerModalTitle')" class="modal-header">
              {{ content.disclaimerTitle }}
            </h2>
            <div :id="$id('disclaimerModalDescription')" tabindex="-1" class="modal-text-content text-sm px-4" v-dompurify-html="content.disclaimerText"/>
            <KButton
              :aria-label="content.disclaimerClose"
              @click="showDisclaimerModal = false"
              @keypress.enter.space="showDisclaimerModal = false"
              theme="secondary"
              class="border-0 shadow-none"
              tabindex="0"
            >
              {{ content.disclaimerClose }}
            </KButton>
          </div>
        </template>
      </KModal>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import KModal from '@/components/atoms/Modal/KModal.vue';
import KButton from '@/components/atoms/Button/index.vue';
import Disclaimer from '@/model/Disclaimer'

export default defineComponent({
  name: 'KDisclaimer',
  components: {
    KModal,
    KButton
  },
  props: {
    disclaimerText: {
      type: String,
      default: 'All member out-of-pocket results are estimates and may not represent your actual purchase. This optional tool does not work with electronic assistive technology. If you are using a screen reader and would like an estimate on your out-of-pocket cost, please contact our customer care center.'
    },
    content: {
      type: Disclaimer,
      required: true,
      validator: (value: Disclaimer) => value instanceof Disclaimer
    }
  },
  setup () {
    const showDisclaimerModal = ref(false)
    function openModal () {
      showDisclaimerModal.value = true
    }
    return { showDisclaimerModal, openModal }
  }
})
</script>

<style scoped>
.k-disclaimer {
  &__content {
    padding: 10px 30px;
    border-top: 5px solid #EFECEC;
    max-width: 1038px;
  }

  #kbyg_footers {
    max-height: 60px;
    overflow-y: auto;
  }
}
</style>
